import { render, staticRenderFns } from "./CocinaeasylunchAutomodal.vue?vue&type=template&id=56f7c861&"
import script from "./CocinaeasylunchAutomodal.vue?vue&type=script&lang=js&"
export * from "./CocinaeasylunchAutomodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports